export default "__VITE_ASSET__B$gQW213__"